module.exports = __webpack_public_path__ + "img/preview-avatar-verification.4851cdda.svg";